import {
  DSButton,
  DSCardWrapper,
} from "@components/design-system/molecules";
import { faLock, faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import mixpanel from "mixpanel-browser";
import React from "react";

import { handleSubscribe } from "../../../api/Billing";
import { UNLIMITED_PRICE_ID_MONTHLY } from "../../../constants";

const FEATURES = [
  "Upload an existing template PDF for an easy transition",
  "Favorite templates for quick access",
  "Share templates with your team",
  "Use Scribenote's templates as a starting point",
];

export default function TemplatesFreePlanState() {
  const handleUpgrade = () => {
    handleSubscribe({
      priceId: UNLIMITED_PRICE_ID_MONTHLY,
      route: "/templates",
    });
    mixpanel.track("Upgrade Plan Clicked", {
      featureName: "Adaptive Templates",
    });
  };

  return (
    <div
      className="flex flex-col items-center justify-center max-w-3xl mx-auto py-12 px-4"
      data-testid="templates-free-plan-state"
    >
      <div className="text-center mb-8">
        <div className="inline-flex items-center justify-center bg-brand-subtle rounded-full p-2 mb-md">
          <FontAwesomeIcon
            icon={faLock}
            className="text-brand"
            size="lg"
          />
        </div>
        <h2 className="text-2xl font-semibold text-primary mb-sm">
          Unlock Adaptive Templates
        </h2>
        <p className="text-secondary text-lg max-w-2xl mx-auto">
          Create custom templates that adapt to the way you write
          notes and let Scribenote <i>Scribe Like You</i>. Watch to
          learn how you can use Adaptive Templates to save even more
          time on your notes:
        </p>
      </div>

      <div className="w-full max-w-2xl aspect-video rounded-large overflow-hidden shadow-lg bg-gray-900">
        <iframe
          src="https://www.youtube.com/embed/YQeVKqZXBHk"
          title="Scribenote Templates Demo"
          className="w-full h-full"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>

      <div className="mt-10 text-center">
        <h3 className="text-lg font-bold text-primary mb-md">
          What you'll get with Adaptive Templates:
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-md max-w-2xl mx-auto text-left">
          {FEATURES.map((feature) => (
            <DSCardWrapper
              key={feature}
              variant="default"
              padding="p-sm"
              dataTestId="feature-card"
            >
              <div className="flex items-start space-x-3">
                <div className="shrink-0 w-6 h-6 rounded-full bg-green-100 dark:bg-green-900 flex items-center justify-center">
                  <FontAwesomeIcon
                    icon={faCheck}
                    className="text-green-600 dark:text-green-400 text-xs"
                  />
                </div>
                <span className="text-secondary">{feature}</span>
              </div>
            </DSCardWrapper>
          ))}
        </div>
      </div>

      <div className="mt-10">
        <DSButton
          onClick={handleUpgrade}
          icon={faLock}
          dataTestId="upgrade-plan-button"
        >
          Get Access to Adaptive Templates
        </DSButton>
      </div>
    </div>
  );
}
